module.exports = __webpack_public_path__ + "static/security-updates-linux-only-5d516ab0ffd1f8d53ef610472b5b2c48.png";